import { ReactNode } from 'react';
import './EditorialContent.scss';

interface EditorialContentProps {
  children?: ReactNode;
}

export function EditorialContent({ children }: EditorialContentProps) {
  return (
    <div className="editorial-content">
      <div className="editorial-content__wrapper">
        {children}
      </div>
    </div>
  );
}

export default EditorialContent;
